import { playerIdNameParser } from '../commonInbounds/utils/playerInboundUtils';
import { numberParser } from '../inboundParsers';
export const SIDE_BET_ADDED_PAYLOAD_DEFINITION = {
    definitionParts: [
        { name: 'numSideBets', parser: numberParser },
        { name: 'sideBetJacksPotTotal', parser: numberParser },
        { name: 'sideBetJacksCost', parser: numberParser },
        { name: 'bettorPlayer', parser: playerIdNameParser },
        { name: 'targetPlayer', parser: playerIdNameParser }
    ]
};
